import { ADD_PARENT_TO_REQUEST } from "../../../../enums/Request/request.types";

export const addParentAction = (data) => {
    return {
        type: ADD_PARENT_TO_REQUEST,
        payload: data,
    };
};
